export default "__VITE_ASSET__BpoK6Gln__"